function _objectWithoutPropertiesLoose(a, b) {
  if (null == a) return {};
  var c,
      d,
      e = {},
      f = Object.keys(a);

  for (d = 0; d < f.length; d++) {
    c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
  }

  return e;
}

function _inheritsLoose(a, b) {
  a.prototype = Object.create(b.prototype), a.prototype.constructor = a, a.__proto__ = b;
}

function _assertThisInitialized(a) {
  if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

import React from "react";
import PropTypes from "prop-types";
import localPoint from "@vx/event/build/localPoint";
import withTooltip from "@vx/tooltip/build/enhancers/withTooltip";
import TooltipWithBounds, { withTooltipPropTypes as vxTooltipPropTypes } from "@vx/tooltip/build/tooltips/TooltipWithBounds";
export { default as Tooltip } from "@vx/tooltip/build/tooltips/Tooltip";
export var withTooltipPropTypes = {
  onMouseMove: PropTypes.func,
  // expects to be called like func({ event, datum })
  onMouseLeave: PropTypes.func,
  // expects to be called like func({ event, datum })
  tooltipData: PropTypes.any
};
export var propTypes = _extends({}, vxTooltipPropTypes, {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  className: PropTypes.string,
  HoverStyles: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  renderTooltip: PropTypes.func,
  styles: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  TooltipComponent: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  tooltipProps: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  tooltipTimeout: PropTypes.number
});

var defaultProps = {
  className: null,
  HoverStyles: function a() {
    return React.createElement("style", {
      type: "text/css"
    }, "\n      .vx-arc:hover,\n      .vx-bar:hover,\n      .vx-glyph-dot:hover {\n        opacity: 0.7;\n      }\n    ");
  },
  renderTooltip: null,
  styles: {
    display: "inline-block",
    position: "relative"
  },
  TooltipComponent: TooltipWithBounds,
  tooltipProps: null,
  tooltipTimeout: 200
},
    WithTooltip = /*#__PURE__*/function (a) {
  function b(b) {
    var c;
    return c = a.call(this, b) || this, c.handleMouseMove = c.handleMouseMove.bind(_assertThisInitialized(_assertThisInitialized(c))), c.handleMouseLeave = c.handleMouseLeave.bind(_assertThisInitialized(_assertThisInitialized(c))), c.tooltipTimeout = null, c;
  }

  _inheritsLoose(b, a);

  var c = b.prototype;
  return c.componentWillUnmount = function a() {
    this.tooltipTimeout && clearTimeout(this.tooltipTimeout);
  }, c.handleMouseMove = function h(a) {
    var b = a.event,
        c = a.datum,
        d = a.coords,
        e = _objectWithoutPropertiesLoose(a, ["event", "datum", "coords"]),
        f = this.props.showTooltip;

    this.tooltipTimeout && clearTimeout(this.tooltipTimeout);
    var g = {
      x: 0,
      y: 0
    };
    b && b.target && "focus" !== b.type && b.target.ownerSVGElement && (g = localPoint(b.target.ownerSVGElement, b)), g = _extends({}, g, d), f({
      tooltipLeft: g.x,
      tooltipTop: g.y,
      tooltipData: _extends({
        event: b,
        datum: c
      }, e)
    });
  }, c.handleMouseLeave = function d() {
    var a = this.props,
        b = a.tooltipTimeout,
        c = a.hideTooltip;
    this.tooltipTimeout = setTimeout(function () {
      c();
    }, b);
  }, c.render = function o() {
    var a = this.props,
        b = a.children,
        c = a.className,
        d = a.HoverStyles,
        e = a.tooltipData,
        f = a.tooltipOpen,
        g = a.tooltipLeft,
        h = a.tooltipTop,
        i = a.tooltipProps,
        j = a.renderTooltip,
        k = a.styles,
        l = a.TooltipComponent,
        m = {
      onMouseMove: this.handleMouseMove,
      onMouseLeave: this.handleMouseLeave,
      tooltipData: e
    },
        n = j && f && l && j(e);
    return React.createElement("div", {
      style: k,
      className: c
    }, "function" == typeof b ? b(m) : React.cloneElement(React.Children.only(b), m), !!n && React.createElement(l, _extends({
      key: Math.random(),
      top: h,
      left: g
    }, i), n), d && React.createElement(d, null));
  }, b;
}(React.PureComponent);

WithTooltip.propTypes = propTypes, WithTooltip.defaultProps = defaultProps;
export default withTooltip(WithTooltip);